import { StrictRouteConfig } from "@/router/router";

export const reportRoutes: StrictRouteConfig[] = [
    {
        path: "/customers/:customerId/reports/contact-trace",
        name: "contact-trace",
        component: () => import(/* webpackChunkName: "floor" */ "@/views/reports/contact-trace.vue"),
        meta: {
            requiresAuth: true,
            label: "Contact Trace",
            title: "Contact Trace Report",
            includeInSubNavigation: false,
            icon: "selection",
            matchExact: false,
            path: ["dashboard", "offices", "office", "zones"],
            order: 30,
        },
    },
    {
        path: "/customers/:customerId/reports/presence",
        name: "presence-report",
        component: () => import(/* webpackChunkName: "floor" */ "@/views/reports/presence.vue"),
        meta: {
            requiresAuth: true,
            label: "Presence report",
            title: "Presence Report",
            includeInSubNavigation: false,
            icon: "selection",
            matchExact: false,
            path: ["dashboard", "offices", "office", "zones"],
            order: 30,
        },
    },
];
